'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NotoSansUIBold = require('./assets/fonts/NotoSansUI-Bold.eot');

var _NotoSansUIBold2 = _interopRequireDefault(_NotoSansUIBold);

var _NotoSansUIBold3 = require('./assets/fonts/NotoSansUI-Bold.ttf');

var _NotoSansUIBold4 = _interopRequireDefault(_NotoSansUIBold3);

var _NotoSansUIBold5 = require('./assets/fonts/NotoSansUI-Bold.woff');

var _NotoSansUIBold6 = _interopRequireDefault(_NotoSansUIBold5);

var _NotoSansUIBoldItalic = require('./assets/fonts/NotoSansUI-BoldItalic.eot');

var _NotoSansUIBoldItalic2 = _interopRequireDefault(_NotoSansUIBoldItalic);

var _NotoSansUIBoldItalic3 = require('./assets/fonts/NotoSansUI-BoldItalic.ttf');

var _NotoSansUIBoldItalic4 = _interopRequireDefault(_NotoSansUIBoldItalic3);

var _NotoSansUIBoldItalic5 = require('./assets/fonts/NotoSansUI-BoldItalic.woff');

var _NotoSansUIBoldItalic6 = _interopRequireDefault(_NotoSansUIBoldItalic5);

var _NotoSansUIItalic = require('./assets/fonts/NotoSansUI-Italic.eot');

var _NotoSansUIItalic2 = _interopRequireDefault(_NotoSansUIItalic);

var _NotoSansUIItalic3 = require('./assets/fonts/NotoSansUI-Italic.ttf');

var _NotoSansUIItalic4 = _interopRequireDefault(_NotoSansUIItalic3);

var _NotoSansUIItalic5 = require('./assets/fonts/NotoSansUI-Italic.woff');

var _NotoSansUIItalic6 = _interopRequireDefault(_NotoSansUIItalic5);

var _NotoSansUIRegular = require('./assets/fonts/NotoSansUI-Regular.eot');

var _NotoSansUIRegular2 = _interopRequireDefault(_NotoSansUIRegular);

var _NotoSansUIRegular3 = require('./assets/fonts/NotoSansUI-Regular.ttf');

var _NotoSansUIRegular4 = _interopRequireDefault(_NotoSansUIRegular3);

var _NotoSansUIRegular5 = require('./assets/fonts/NotoSansUI-Regular.woff');

var _NotoSansUIRegular6 = _interopRequireDefault(_NotoSansUIRegular5);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderSrc = function renderSrc(eot, woff, ttf) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$dirname = options.dirname,
      dirname = _options$dirname === undefined ? '' : _options$dirname;


  return 'url("' + _path2.default.join(dirname, eot) + '") format("eot"),\n      url("' + _path2.default.join(dirname, eot) + '?#iefix") format("embedded-opentype"),\n      url("' + _path2.default.join(dirname, woff) + '") format("woff"),\n      url("' + _path2.default.join(dirname, ttf) + '") format("truetype")';
};

exports.default = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    '@font-face': [{
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIRegular2.default, _NotoSansUIRegular6.default, _NotoSansUIRegular4.default, options)
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBold2.default, _NotoSansUIBold6.default, _NotoSansUIBold4.default, options),
      fontWeight: 500
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBold2.default, _NotoSansUIBold6.default, _NotoSansUIBold4.default, options),
      fontWeight: 700
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIItalic2.default, _NotoSansUIItalic6.default, _NotoSansUIItalic4.default, options),
      fontStyle: 'italic'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBoldItalic2.default, _NotoSansUIBoldItalic6.default, _NotoSansUIBoldItalic4.default, options),
      fontWeight: 500,
      fontStyle: 'italic'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBoldItalic2.default, _NotoSansUIBoldItalic6.default, _NotoSansUIBoldItalic4.default, options),
      fontWeight: 700,
      fontStyle: 'italic'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIItalic2.default, _NotoSansUIItalic6.default, _NotoSansUIItalic4.default, options),
      fontWeight: 500,
      fontStyle: 'oblique'
    }, {
      fontFamily: 'Noto Sans',
      src: renderSrc(_NotoSansUIBoldItalic2.default, _NotoSansUIBoldItalic6.default, _NotoSansUIBoldItalic4.default, options),
      fontWeight: 700,
      fontStyle: 'oblique'
    }]
  };
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/fonts.js
// module id = 1877
// module chunks = 32